import React from 'react';
import { Router, browserHistory as history } from 'react-router';
import { Provider } from 'react-redux';
import { initialize } from './sessionActions';
import store from './store';
import routes from './routes';

Math.sum = arr => arr.reduce((a, b) => a + b, 0);

store.dispatch(initialize(window.location.pathname));

export default () => (
    <Provider store={store}>
        <Router routes={routes} history={history} onUpdate={() => document.getElementById('content').focus()} />
    </Provider>
);
